// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"wO-z","loadingMedia":"xO-z","reviewsImagesAndVideos":"yO-z","limitHeight":"zO-z"};